import { Link, useLocation } from "react-router-dom";
import PublicFooter from "../components/PublicFooter";

export default function ReservationSuccess() {
  const location = useLocation();
  const { trailer, customer, reservation, selectedOptions = [] } = location.state || {};

  return (
    <main className="public-shell">
      <aside className="public-sidebar">
        <div className="sidebar-brand">
          <p className="sidebar-brand-title">DR-Renting</p>
          <p className="sidebar-brand-subtitle">Aanbod</p>
        </div>
        <Link className="sidebar-button" to="/">Homepagina</Link>
      </aside>

      <section className="public-page">
        <div className="panel panel-pad public-intro">
          <h1 className="page-title">Reservatie succesvol aangevraagd</h1>
          <p className="page-subtitle">We hebben je aanvraag goed ontvangen. Een medewerker volgt dit verder op.</p>

          <div className="detail-section">
            <h2 className="detail-title">Overzicht</h2>
            <div className="detail-grid">
              <div className="detail-item"><div className="detail-label">Trailer</div><div className="detail-value">{trailer?.name || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Periode</div><div className="detail-value">{customer?.startDate || "-"} tot {customer?.endDate || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Klant</div><div className="detail-value">{customer ? `${customer.firstName} ${customer.name}` : "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Telefoon</div><div className="detail-value">{customer?.phone || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">E-mail</div><div className="detail-value">{customer?.email || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Adres</div><div className="detail-value">{customer?.address || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Reservatiecode</div><div className="detail-value">{reservation?.reservationCode || "-"}</div></div>
              <div className="detail-item"><div className="detail-label">Gekozen opties</div><div className="detail-value">{selectedOptions.length ? selectedOptions.join(", ") : "Geen opties gekozen"}</div></div>
            </div>
          </div>

          {customer?.wantsInvoice && (
            <div className="detail-section">
              <h2 className="detail-title">Factuurgegevens</h2>
              <div className="detail-grid">
                <div className="detail-item"><div className="detail-label">Factuur gewenst</div><div className="detail-value">Ja</div></div>
                <div className="detail-item"><div className="detail-label">BTW-nummer</div><div className="detail-value">{customer.vatNumber || "-"}</div></div>
              </div>
            </div>
          )}

          <Link className="button" to="/">Terug naar homepagina</Link>
        </div>
        <PublicFooter />
      </section>
    </main>
  );
}
